/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { GlobalState } from '../../actions';

export const playlistSearchState = (state: GlobalState) => state.playlistAdmin.playlistSearch;

export const playlistSearchString = (state: GlobalState) => playlistSearchState(state).searchString;

export const playlistSearchList = (state: GlobalState) => playlistSearchState(state).list;

export const playlistSearchCount = (state: GlobalState) => playlistSearchState(state).searchCount;

export const playlistSearchCurrentPos = (state: GlobalState) => playlistSearchState(state).searchCurrentPos;

export const playlistSearchPageSize = (state: GlobalState) => playlistSearchState(state).searchPageSize;

export const playlistSearchFromDate = (state: GlobalState) => playlistSearchState(state).fromDate;

export const playlistSearchToDate = (state: GlobalState) => playlistSearchState(state).toDate;

export const playlistSearchIsLoading = (state: GlobalState) => playlistSearchState(state).isLoading;
